"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSCookie = require("js-cookie");
var Env_1 = require("./Env");
var Cookies = {
    set: function (key, value, expireDate) {
        JSCookie.set(key, value, {
            domain: Env_1.COOKIE_DOMAIN,
            secure: Env_1.SECURE_COOKIES,
            expires: expireDate,
            path: '/',
            // cookies only read if this is a rowan site
            sameSite: 'lax'
        });
    },
    remove: function (key) {
        JSCookie.remove(key, {
            domain: Env_1.COOKIE_DOMAIN,
            secure: Env_1.SECURE_COOKIES,
            path: '/'
        });
    },
    get: function (key) { return JSCookie.get(key); }
};
exports.default = Cookies;
